"use strict";

exports.__esModule = true;
var _Feature = _interopRequireDefault(require("./Feature"));
exports.default = _Feature.default;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}